import { api } from "../core/api.js";
import { h } from "../core/dom.js";
import { navigate } from "../core/router.js";
import { t } from "../core/i18n.js";
import { loadInto } from "../core/states.js";
import type { Episode, Title } from "../models.js";

interface TitleDetail extends Title {
  episodes: Episode[];
}
interface CutLite {
  id: string;
  kind: "original" | "user";
  name?: string | null;
}

export async function titleView(params: Record<string, string>, root: HTMLElement): Promise<void> {
  const id = params.id ?? "";
  await loadInto<TitleDetail>({
    root,
    load: () => api.get<TitleDetail>(`/v1/titles/${id}`),
    render: (detail) => {
      const epList = h(
        "div",
        {},
        ...(detail.episodes ?? []).map((ep) => {
          const epLabel = t("title.episodeLabel", { idx: ep.idx, name: ep.name ?? "" });
          return h(
            "div",
            { class: "card", style: "padding:12px;margin:8px 0;display:flex;align-items:center;gap:12px" },
            h("span", {}, epLabel),
            h(
              "button",
              {
                type: "button",
                class: "btn",
                style: "margin-left:auto",
                "aria-label": `${t("common.play")}: ${epLabel}`,
                onclick: () => playEpisode(ep.id),
              },
              t("common.play"),
            ),
          );
        }),
      );
      return h(
        "section",
        {},
        h("h1", {}, detail.title, " ", h("span", { class: "badge ai" }, t("compliance.aiBadge"))),
        h("p", { class: "muted" }, detail.synopsis ?? ""),
        h("h3", {}, t("title.episodes")),
        epList,
      );
    },
  });
}

async function playEpisode(episodeId: string): Promise<void> {
  try {
    const cuts = await api.get<{ items: CutLite[] }>(`/v1/episodes/${episodeId}/cuts`);
    const original = cuts.items.find((c) => c.kind === "original") ?? cuts.items[0];
    if (original) navigate(`/watch/${original.id}`);
    else alert(t("title.noCut"));
  } catch {
    alert(t("title.cutLoadFailed"));
  }
}
